import React from 'react';
import PropTypes from 'prop-types';
import Loader from '@techsoftware/happay-widgets/Loader';
import "./style.scss";

function CustomLoader(props) {
  const { loader, loaderText } = props;

  return (
    <Loader 
      loader={loader} 
      loaderText={loaderText}
    />
  );
}

export default CustomLoader;

CustomLoader.propTypes = {
  loader: PropTypes.bool,
  loaderText: PropTypes.node
};

CustomLoader.defaultProps = {
  loader: false,
};
